import React, { Component, Fragment, useEffect, useState, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import _ from "lodash";
import Swal from "sweetalert2";
import { login } from "../../../Services/LoginServices";
import {
  getFullMasterForProviderList,
  updateProvider,
  getProviderById,
  deleteProviderById,
} from "../../../Services/ProviderServices";
import { utils } from "../../../helpers/utils";
import { AxiosResponse } from "axios";

export type ProviderFormValues = {
  [key: string]: any;
};

export type ProviderFormRef = {
  [key: string]: React.RefObject<HTMLElement | null>;
};

export type ProviderFormErrors = {
  [key: string]: string;
};

export type ProviderFormTouched = {
  [key: string]: boolean;
};

export type ValidtionFunctions = {
  [key: string]: Function;
};

export type ProviderFormMasterData = {
  [key: string]: {
    id: number;
    displayName: string;
    iconName?: string | null;
  }[];
};

export function useProviderForm(isCreate: boolean) {
  const history = useHistory();

  let { proivderId } = useParams<{ proivderId: string }>();

  useEffect(() => {
    fetchData(isCreate !== undefined ? isCreate : true);
  }, []);

  async function fetchData(isCreate: boolean, providerId?: number) {
    try {
      if (isCreate) {
        getFullMasterForProviderList().then((response) => {
          if (response.status === 200 && response.data) {
            let result: any = {};
            Object.keys(response.data as ProviderFormMasterData).forEach(
              (key) => {
                result[key] = (response.data as ProviderFormMasterData)[
                  key
                ].map((item) => {
                  return {
                    text: item.displayName,
                    value: item.id,
                    key: item.id,
                  };
                });
              }
            );
            setMasterData(result as ProviderFormMasterData);
          } else {
            throw new Error("Unable to fetch master data!");
          }
        });
      } else {
        getFullMasterForProviderList().then((response) => {
          if (response.status === 200 && response.data) {
            let result: any = {};
            Object.keys(response.data as ProviderFormMasterData).forEach(
              (key) => {
                result[key] = (response.data as ProviderFormMasterData)[
                  key
                ].map((item) => {
                  return {
                    text: item.displayName,
                    value: item.id,
                    key: item.id,
                  };
                });
              }
            );
            setMasterData(result as ProviderFormMasterData);
          } else {
            throw new Error("Unable to fetch master data!");
          }
        });
        // also get provider data
        if (proivderId) {
          const id: number = parseInt(proivderId);
          getProviderById(id, false).then((response) => {
            if (response && response.status === 200 && response.data) {
              console.log(response.data);
              console.log(values);
              let newValues: ProviderFormValues = _.cloneDeep(
                response.data
              ) as ProviderFormValues;
              delete newValues.providerId;
              newValues.providerPhone = utils.formatPhoneNumber(
                newValues.providerPhone
              );
              setValues(newValues);
            } else {
              throw new Error("Unable to fetch provider data!");
            }
          });
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error While Processing",
        text: `Unable to get master data for the form.`,
        showConfirmButton: true,
        confirmButtonText: "OK",
        confirmButtonColor: "#1678c2",
      }).then(() => {});
    }
  }

  const defaultValues: ProviderFormValues = {
    categoryId: 0,
    providerName: "",
    websiteURL: "",
    providerTypeId: 1,
    credentialIds: [],
    trainingOfferIds: [],
    providerAddress: "",
    providerContact: "",
    providerPhone: "",
    providerEmail: "",
  };
  const validations = {
    categoryId: async function (values: ProviderFormValues) {
      // Do validation here
      // two promises, one for local, one for async, usually serverside.
      let error: string | null = null;
      let promises = [
        new Promise((resolve, reject) => {
          // local validation logic here.
          if (!values.categoryId) {
            error = "Please select a category";
          }
          if (error != null) {
            reject(error);
          } else {
            resolve(null);
          }
        }),
        new Promise((resolve, reject) => {
          // do server validation logic here.
          resolve(null);
        }),
      ];
      let result = await Promise.all(promises);
      return result;
    },
    providerName: async function (values: ProviderFormValues) {
      // Do validation here
      // two promises, one for local, one for async, usually serverside.
      let error: string | null = null;
      let promises = [
        new Promise((resolve, reject) => {
          // local validation logic here.
          if (!values.providerName) {
            error = "Please enter provider name";
          }
          if (error != null) {
            reject(error);
          } else {
            resolve(null);
          }
        }),
        new Promise((resolve, reject) => {
          // do server validation logic here.
          resolve(null);
        }),
      ];
      let result = await Promise.all(promises);
      return result;
    },
    websiteURL: async function (values: ProviderFormValues) {
      // Do validation here
      // two promises, one for local, one for async, usually serverside.
      let error: string | null = null;
      let promises = [
        new Promise((resolve, reject) => {
          // local validation logic here.
          if (
            values.websiteURL &&
            !(
              values.websiteURL.startsWith("http://") ||
              values.websiteURL.startsWith("https://")
            )
          ) {
            error =
              'Please enter a valid URL which start with "http://" or "https://"';
          }

          if (error != null) {
            reject(error);
          } else {
            resolve(null);
          }
        }),
        new Promise((resolve, reject) => {
          // do server validation logic here.
          resolve(null);
        }),
      ];
      let result = await Promise.all(promises);
      return result;
    },
    providerTypeId: async function (values: ProviderFormValues) {
      // Do validation here
      // two promises, one for local, one for async, usually serverside.
      let error: string | null = null;
      let promises = [
        new Promise((resolve, reject) => {
          // local validation logic here.
          if (!values.providerTypeId) {
            error = "Please select provider type";
          }
          if (error != null) {
            reject(error);
          } else {
            resolve(null);
          }
        }),
        new Promise((resolve, reject) => {
          // do server validation logic here.
          resolve(null);
        }),
      ];
      let result = await Promise.all(promises);
      return result;
    },
    credentialIds: async function (values: ProviderFormValues) {
      // Do validation here
      // two promises, one for local, one for async, usually serverside.
      let error: string | null = null;
      let promises = [
        new Promise((resolve, reject) => {
          // local validation logic here.
          if (!(values.credentialIds && values.credentialIds.length > 0)) {
            error = "Please select at least one credential";
          }
          if (error != null) {
            reject(error);
          } else {
            resolve(null);
          }
        }),
        new Promise((resolve, reject) => {
          // do server validation logic here.
          resolve(null);
        }),
      ];
      let result = await Promise.all(promises);
      return result;
    },
    trainingOfferIds: async function (values: ProviderFormValues) {
      // Do validation here
      // two promises, one for local, one for async, usually serverside.
      let error: string | null = null;
      let promises = [
        new Promise((resolve, reject) => {
          // local validation logic here.
          if (
            !(values.trainingOfferIds && values.trainingOfferIds.length > 0)
          ) {
            error = "Please select at least one training option";
          }
          if (error != null) {
            reject(error);
          } else {
            resolve(null);
          }
        }),
        new Promise((resolve, reject) => {
          // do server validation logic here.
          resolve(null);
        }),
      ];
      let result = await Promise.all(promises);
      return result;
    },
    providerAddress: async function (values: ProviderFormValues) {
      // Do validation here
      // two promises, one for local, one for async, usually serverside.
      let error: string | null = null;
      let promises = [
        new Promise((resolve, reject) => {
          // local validation logic here.

          if (error != null) {
            reject(error);
          } else {
            resolve(null);
          }
        }),
        new Promise((resolve, reject) => {
          // do server validation logic here.
          resolve(null);
        }),
      ];
      let result = await Promise.all(promises);
      return result;
    },
    providerContact: async function (values: ProviderFormValues) {
      // Do validation here
      // two promises, one for local, one for async, usually serverside.
      let error: string | null = null;
      let promises = [
        new Promise((resolve, reject) => {
          // local validation logic here.

          if (error != null) {
            reject(error);
          } else {
            resolve(null);
          }
        }),
        new Promise((resolve, reject) => {
          // do server validation logic here.
          resolve(null);
        }),
      ];
      let result = await Promise.all(promises);
      return result;
    },
    providerPhone: async function (values: ProviderFormValues) {
      // Do validation here
      // two promises, one for local, one for async, usually serverside.
      let error: string | null = null;
      let promises = [
        new Promise((resolve, reject) => {
          // local validation logic here.
          if (
            values.providerPhone &&
            !utils.isValidPhone(values.providerPhone)
          ) {
            error =
              "Please enter a valid phone number which conains at least 10 digits in any format";
          }
          if (error != null) {
            reject(error);
          } else {
            resolve(null);
          }
        }),
        new Promise((resolve, reject) => {
          // do server validation logic here.
          resolve(null);
        }),
      ];
      let result = await Promise.all(promises);
      return result;
    },
    providerEmail: async function (values: ProviderFormValues) {
      // Do validation here
      // two promises, one for local, one for async, usually serverside.
      let error: string | null = null;
      let promises = [
        new Promise((resolve, reject) => {
          // local validation logic here.
          if (
            values.providerEmail &&
            isValidEmail(values.providerEmail) !== true
          ) {
            error = "Please provide a valid email";
          }
          if (error != null) {
            reject(error);
          } else {
            resolve(null);
          }
        }),
        new Promise((resolve, reject) => {
          // do server validation logic here.
          resolve(null);
        }),
      ];
      let result = await Promise.all(promises);
      return result;
    },
  };

  let isSubmit = false;
  const debounceTime = 250;
  const ref = useRef(initRefs(defaultValues));
  const [values, setValues] = useState<ProviderFormValues>(defaultValues);
  const [errors, setErrors] = useState<ProviderFormErrors>({});
  const [touched, setTouched] = useState<ProviderFormTouched>({});
  //const debouncedValidateForm = _.debounce(validateForm, debounceTime);
  const debouncedValidateForm = validateForm;
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [masterData, setMasterData] = useState<ProviderFormMasterData | null>(
    null
  );

  let validationCount = 0;
  let validationTotal = 1;

  function initRefs(viewModel: ProviderFormValues) {
    if (viewModel == null) {
      return {};
    } else {
      let result: ProviderFormRef = {};
      Object.keys(viewModel).forEach((key) => {
        result[key] = React.createRef<HTMLElement | null>();
      });
      return result;
    }
  }

  function registerRef(ref: HTMLElement | null) {
    console.log(ref);
    console.log(typeof ref);
  }

  function touchAll() {
    let keys = Object.keys(defaultValues);
    keys.forEach((key) => {
      touched[key] = true;
    });
    setTouched(touched);
  }

  function counterHit(currentError: ProviderFormErrors) {
    validationCount += 1;
    // we did not handle timeout problem, but it will in future
    if (validationCount === validationTotal) {
      validationCount = 0;
      if (_.isEmpty(currentError)) {
        setIsValid(true);
        if (isSubmit === true) {
          isSubmit = false;
          setIsLoading(true);
          saveData({ ...values });
        } else {
          setIsLoading(false);
        }
      } else {
        if (isSubmit === true) {
          isSubmit = false;
        }
        if (isValid !== false) {
          setIsValid(false);
        }
        setIsLoading(false);
      }
    }
  }

  function handleDelete() {
    Swal.fire({
      text: "Are you sure to delete this provider?",
      title: "Confirm Delete Provider",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      showConfirmButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        deleteProviderById(parseInt(proivderId)).then(
          (res) => {
            setIsLoading(false);
            if (res && res.status === 200) {
              if ((res.data as any).isDeleted === true) {
                Swal.fire({
                  icon: "success",
                  title: "Provider deleted!",
                  toast: true,
                  position: "top-end",
                  timerProgressBar: true,
                  timer: 5000,
                  showConfirmButton: false,
                });
                history.push("/providers");
              }
            } else {
              throw new Error("Failed to delete provider.");
            }
          },
          (error) => {
            setIsLoading(false);
            throw new Error("Failed to delete provider.");
          }
        );
      }
    });
  }

  function saveData(viewModel: ProviderFormValues) {
    setIsSubmitting(true);
    setIsLoading(true);
    setErrorMessage(null);
    let newData = _.cloneDeep(viewModel);
    newData.providerId = isCreate ? 0 : parseInt(proivderId);
    newData.providerPhone = utils.formatPhoneNumber(newData.providerPhone);
    updateProvider(newData, isCreate).then(
      (res) => {
        setIsLoading(false);
        setIsSubmitting(false);
        if (res && res.status === 200) {
          Swal.fire({
            icon: "success",
            title:
              "Provider " +
              (isCreate ? "created" : "updated") +
              " successfully",
            text: "",
            showConfirmButton: true,
            confirmButtonText: "OK",
            confirmButtonColor: "#1678c2",
          }).then(() => {
            history.push("/providers");
          });
        } else if (res && res.status === 401) {
          setIsValid(false);
          setErrorMessage("Invalid user name or password.");
        } else {
          Swal.fire({
            icon: "error",
            title: "Error While Processing",
            text: `${
              res && res.data ? res.data : "No detail reason available."
            }`,
            showConfirmButton: true,
            confirmButtonText: "OK",
            confirmButtonColor: "#1678c2",
          }).then(() => {});
        }
      },
      (error) => {
        setIsLoading(false);
        setIsSubmitting(false);
        if (
          error.response &&
          error.response.data &&
          error.response.status === 500
        ) {
          let footer = "";
          Swal.fire({
            icon: "error",
            title: "Error While Processing",
            text: `${
              error.response.data
                ? error.response.data
                : "No detail reason available"
            }`,
            showConfirmButton: true,
            footer: footer,
            confirmButtonText: "OK",
          }).then(() => {});
        }
      }
    );
  }

  function resetForm() {
    Object.keys(defaultValues).forEach((key, index) => {
      let temp = ref.current[key].current;
      if (temp != null) {
        // not implemented yet
      }
    });
    setValues(defaultValues);
    setIsLoading(false);
    setTouched({});
    setErrors({});
  }

  async function handleSubmit() {
    touchAll();
    setIsLoading(true);
    validateForm(values, validations, null);
    isSubmit = true;
  }

  function validateForm(
    values: ProviderFormValues,
    validations: ValidtionFunctions,
    fieldName: string | null = null
  ) {
    let newErrors: ProviderFormErrors = {};
    setIsLoading(true);
    if (fieldName != null) {
      // only validate the changing field.Keep current errors info
      newErrors = errors;
      validationTotal = 1;
      validationCount = 0;
      validations[fieldName](values).then(
        () => {
          delete newErrors[fieldName];
          setErrors(newErrors);
          counterHit(newErrors);
        },
        (error: string) => {
          newErrors[fieldName] = error;
          setErrors(newErrors);
          counterHit(newErrors);
        }
      );
    } else {
      // if this validate is not trigered by input control change, validate all.
      let keys = Object.keys(defaultValues);
      validationTotal = keys.length > 0 ? keys.length : 0;
      validationCount = 0;
      keys.forEach((key) => {
        validations[key](values).then(
          () => {
            delete newErrors[key];
            setErrors(newErrors);
            counterHit(newErrors);
          },
          (error: string) => {
            newErrors[key] = error;
            setErrors(newErrors);
            counterHit(newErrors);
          }
        );
      });
    }
  }

  function handleBlur(fieldName: string) {
    if (errorMessage != null) {
      setErrorMessage(null);
    }
    setTimeout(() => {
      setTouched((prevValue) => {
        return {
          ...prevValue,
          [fieldName]: true,
        };
      });
      validateForm(values, validations, null);
    }, 250);
  }

  function handleChange(newValue: any, fieldName: string, fieldOnly = true) {
    if (errorMessage != null) {
      setErrorMessage(null);
    }
    if (fieldName === "providerPhone") {
      if (newValue && utils.isValidPhone(newValue)) {
        newValue = utils.formatPhoneNumber(newValue);
        newValue = utils.formatPhoneNumber(newValue);
      }
    }
    values[fieldName] = newValue;
    setValues(values);
    if (!(touched[fieldName] != null)) {
      setTouched({ ...touched, [fieldName]: true });
    }
    debouncedValidateForm(values, validations, fieldOnly ? fieldName : null);
  }

  function isValidEmail(testTarget: string) {
    let myReg = /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi;
    return myReg.test(testTarget);
  }

  return [
    values,
    masterData,
    errors,
    touched,
    isLoading,
    isSubmitting,
    isValid,
    errorMessage,
    registerRef,
    handleChange,
    handleBlur,
    handleSubmit,
    handleDelete,
  ] as const;
}
